import { render } from "./SliderEditor.vue?vue&type=template&id=31db433a&scoped=true"
import script from "./SliderEditor.vue?vue&type=script&lang=js"
export * from "./SliderEditor.vue?vue&type=script&lang=js"

import "./SliderEditor.vue?vue&type=style&index=0&id=31db433a&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-31db433a"

export default script